import React from 'react';
import { ExternalLink, Sparkles, Target, Heart, BookOpen, Users, Zap, Info, Compass } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Card } from './ui/card';

const LikemymindLanding = () => {
  const navigate = useNavigate();
  const blocks = [
    {
      id: 1,
      title: 'Findmino.com',
      language: 'en',
      flags: '🇺🇸 🇨🇦',
      tagline: 'Where Career Discovery Meets Lifestyle Inspiration',
      description: 'Explore 1,100+ careers with salary insights, AI impact analysis, and 800+ study programs. Discover hobbies, activities, and passions across USA & Canada that bring fulfillment to your life. Or browse the amazing School Planning tool, the future-proof alternative to Naviance or Xello, at a fraction of the cost',
      icon: Target,
      link: 'https://findmino.com',
      bgImage: 'https://images.unsplash.com/photo-1604079628040-94301bb21b91?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGdyYWRpZW50fGVufDB8fHx8MTc2MzA2NjU4NXww&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 2,
      title: 'FindMino.nl',
      language: 'nl',
      flags: '🇳🇱',
      tagline: "Waar Carrièreverkenning en Vrijetijdsinspiratie Samenkomen",
      description: "Verken 450+ beroepen met salarisinzichten, AI-impact analyses en 350+ studierichtingen. Ontdek hobby's, activiteiten en passies die plezier en vervulling brengen aan je leven in Nederland. Of bekijk Findmino's indrukwekkende studie- en loopbaan planning tool voor middelbare scholen. Goedkoper dan bestaande alternatieven, ai-gedreven en klaar voor de wereld van morgen.",
      icon: Heart,
      link: 'https://findmino.nl',
      bgImage: 'https://images.unsplash.com/photo-1579548122080-c35fd6820ecb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGdyYWRpZW50fGVufDB8fHx8MTc2MzA2NjU4NXww&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 3,
      title: 'Life @ Career Tools',
      language: 'en',
      flags: '🇺🇸 🇨🇦',
      tagline: 'AI-Powered Personal & Professional Development',
      description: 'Unlock your potential with AI-driven tools for every life situation. From resume builders to interview coaches, goal planners to conflict resolvers—get the best out of yourself and your career.',
      icon: Zap,
      link: 'https://findmino.com/life-career-tools',
      bgImage: 'https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGdyYWRpZW50fGVufDB8fHx8MTc2MzA2NjU4NXww&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 4,
      title: 'Life & Loopbaan Tools',
      language: 'nl',
      flags: '🇳🇱',
      tagline: 'Verfrissende AI Tools voor Persoonlijke Groei',
      description: "Slimme tools om het beste uit jezelf en je carrière te halen. AI-gedreven hulpmiddelen voor sollicitatietraining, conflict management, doelplanning en persoonlijke effectiviteit.",
      icon: Sparkles,
      link: 'https://findmino.nl/life-career-tools',
      bgImage: 'https://images.unsplash.com/photo-1761798983107-a48299f8fb45?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxzb2Z0JTIwcGFzdGVsJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NjMwNjY1OTJ8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 5,
      title: 'CareerCube.io',
      language: 'both',
      flags: '🇺🇸 🇨🇦 🇳🇱',
      tagline: 'Step Up Your Interactive & Personal Effectiveness',
      description: 'Excellent online courses designed to enhance your professional and personal effectiveness. Master communication, leadership, and interpersonal skills that make a real difference in work and life.',
      taglineNL: 'Versterk je Interactieve & Persoonlijke Effectiviteit',
      descriptionNL: "Uitstekende online cursussen om je professionele en persoonlijke effectiviteit te versterken. Beheers communicatie, leiderschap en sociale vaardigheden die écht impact maken.",
      icon: BookOpen,
      link: 'https://careercube.io',
      bgImage: 'https://images.unsplash.com/photo-1761888857629-aa3f306f6bee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHw0fHxzb2Z0JTIwcGFzdGVsJTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NjMwNjY1OTJ8MA&ixlib=rb-4.1.0&q=85'
    },
    {
      id: 6,
      title: 'Findmino-X.nl',
      language: 'nl',
      flags: '🇳🇱',
      tagline: 'Wat doe je ná je pensioen?',
      description: "De ontdekkingsplek voor 50-plussers en (bijna) pensionado's. Vind inspirerende hobby's, boeiende studies, vrijwilligerswerk en verenigingen die passen bij jouw nieuwe levensfase. Blader door de directory, laat je verrassen door de 'Wat als…'-kaarten en lees het magazine vol frisse ideeën. Zo maak je van je pensioen misschien wel de mooiste fase van je leven.",
      icon: Compass,
      link: 'https://findmino-x.nl',
      bgImage: 'https://images.unsplash.com/photo-1557682250-33bd709cbe85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxzb2Z0JTIwcGFzdGVsJTIwZ3JhZGllbnR8ZW58MHx8fHwxNzYzMDY2NTkyfDA&ixlib=rb-4.1.0&q=85'
    }
  ];

  const quiz = {
    title: 'FindMino Swipe Quiz',
    flags: '🇺🇸 🇨🇦 🇳🇱 🇫🇷',
    tagline: 'Discover Who You Really Are',
    description: "A fun, insightful journey to clarify your personality, talents, and interests. Get matched with celebrities, travel destinations, and dishes that resonate with you—plus professional career paths, leisure activities, and like-minded people.",
    taglineNL: 'Ontdek Wie Je Echt Bent',
    descriptionNL: "Een leuke, inzichtelijke reis om je persoonlijkheid, talenten en interesses te ontdekken. Match met celebrities, reisbestemmingen en gerechten—plus professionele carrièrepaden, vrijetijdsactiviteiten en gelijkgestemde mensen.",
    icon: Users,
    linkEN: 'https://findmino.com/swipe-quiz',
    linkNL: 'https://findmino.nl/swipe-quiz',
    bgImage: 'https://images.pexels.com/photos/34714951/pexels-photo-34714951.jpeg'
  };

  const handleExplore = (link) => {
    if (link === '#') {
      alert('Coming soon!');
    } else {
      window.open(link, '_blank');
    }
  };

  return (
    <div className="likemymind-container">
      {/* Header */}
      <header className="likemymind-header">
        <div className="header-content">
          <div className="logo-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_career-leisure-hub/artifacts/wugpgoix_Findmino%20Logo%20purple.png" 
              alt="FindMino Logo" 
              className="site-logo"
            />
            <h1 className="site-title">Likemymind</h1>
          </div>
          <p className="site-subtitle">Connecting Your Potential Across Career, Growth & Life</p>
          <Button 
            className="who-we-are-nav-btn"
            onClick={() => navigate('/who-we-are')}
          >
            <Info className="btn-icon" />
            Who We Are
          </Button>
        </div>
      </header>

      {/* Main Content Grid */}
      <main className="blocks-grid">
        {/* First 2 blocks - Findmino.com and FindMino.nl side by side */}
        {blocks.slice(0, 2).map((block) => {
          const IconComponent = block.icon;
          return (
            <Card key={block.id} className="info-block" style={{
              backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.92), rgba(255, 255, 255, 0.92)), url(${block.bgImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="block-content">
                <div className="icon-wrapper">
                  <IconComponent className="block-icon" />
                </div>
                <div className="title-with-flags">
                  <h2 className="block-title">{block.title}</h2>
                  <span className="block-flags">{block.flags}</span>
                </div>
                <p className="block-tagline">{block.tagline}</p>
                <p className="block-description">{block.description}</p>
                <Button 
                  className="explore-btn"
                  onClick={() => handleExplore(block.link)}
                >
                  Explore <ExternalLink className="btn-icon" />
                </Button>
              </div>
            </Card>
          );
        })}

        {/* Central Quiz Block - Spans 2 columns on desktop */}
        <Card className="quiz-block" style={{
          backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.88), rgba(255, 255, 255, 0.88)), url(${quiz.bgImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}>
          <div className="quiz-content">
            <div className="quiz-icon-wrapper">
              <Users className="quiz-icon" />
            </div>
            <div className="title-with-flags">
              <h2 className="quiz-title">{quiz.title}</h2>
              <span className="quiz-flags">{quiz.flags}</span>
            </div>
            <div className="quiz-bilingual">
              <div className="quiz-section">
                <p className="quiz-tagline">{quiz.tagline}</p>
                <p className="quiz-description">{quiz.description}</p>
                <Button 
                  className="quiz-btn"
                  onClick={() => handleExplore(quiz.linkEN)}
                >
                  Start Quiz <Sparkles className="btn-icon" />
                </Button>
              </div>
              <div className="quiz-divider"></div>
              <div className="quiz-section">
                <p className="quiz-tagline">{quiz.taglineNL}</p>
                <p className="quiz-description">{quiz.descriptionNL}</p>
                <Button 
                  className="quiz-btn"
                  onClick={() => handleExplore(quiz.linkNL)}
                >
                  Doe de Quiz <Sparkles className="btn-icon" />
                </Button>
              </div>
            </div>
          </div>
        </Card>

        {/* Remaining blocks - Life @ Career Tools, Life & Loopbaan Tools, CareerCube, Findmino-X */}
        {blocks.slice(2).map((block) => {
          const IconComponent = block.icon;
          return (
            <Card key={block.id} className="info-block" style={{
              backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.92), rgba(255, 255, 255, 0.92)), url(${block.bgImage})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}>
              <div className="block-content">
                <div className="icon-wrapper">
                  <IconComponent className="block-icon" />
                </div>
                <div className="title-with-flags">
                  <h2 className="block-title">{block.title}</h2>
                  <span className="block-flags">{block.flags}</span>
                </div>
                {block.language === 'both' ? (
                  <>
                    <p className="block-tagline">{block.tagline}</p>
                    <p className="block-description">{block.description}</p>
                    <div className="language-divider"></div>
                    <p className="block-tagline">{block.taglineNL}</p>
                    <p className="block-description">{block.descriptionNL}</p>
                  </>
                ) : (
                  <>
                    <p className="block-tagline">{block.tagline}</p>
                    <p className="block-description">{block.description}</p>
                  </>
                )}
                <Button 
                  className="explore-btn"
                  onClick={() => handleExplore(block.link)}
                >
                  Explore <ExternalLink className="btn-icon" />
                </Button>
              </div>
            </Card>
          );
        })}
      </main>

      {/* Footer */}
      <footer className="likemymind-footer">
        <p className="footer-text">© 2026 likemymind • Connecting platforms that inspire growth and discovery</p>
      </footer>
    </div>
  );
};

export default LikemymindLanding;